import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ChartService } from "../services/ChartService";
import { StatePickerModal } from "./StatePickerModal";
import { ChartData } from "../types/Types";
import "../styles/TrendingCharts.css";
import "../App.css";

export const TrendingCharts = () => {
  const [charts, setCharts] = useState<ChartData[]>([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const loadCharts = async () => {
      const data = await ChartService.fetchTrendingCharts();
      setCharts(data);
      setLoading(false);
    };
    loadCharts();
  }, []);

  const handleNavigate = (alias: string) => {
    navigate(`/chart/${alias}`);
  };

  return (
    <section className="trending-charts-section">
      <StatePickerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      <div className="trending-charts-header">
        <h2 className="scrollable-feed-header">State Charts</h2>
        <button
          onClick={() => setIsModalOpen(true)}
          className="scrollable-feed-btn"
        >
          Go To Chart <ChevronRight size={16} />
        </button>
      </div>

      <div className="trending-charts-scroll-container">
        {loading
          ? Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="skeleton-card">
                <div className="skeleton skeleton-image"></div>
                <div className="skeleton skeleton-text"></div>
              </div>
            ))
          : charts.map((chart) => (
              <div
                key={chart.id}
                className="trending-charts-card"
                onClick={() => handleNavigate(chart.stateNameAlias)}
              >
                <div
                  className="trending-charts-card-image"
                  style={{ backgroundImage: `url(${chart.coverArtUrl})` }}
                >
                  <div className="trending-charts-map-overlay"></div>
                  <img
                    src={chart.stateImage}
                    className="trending-charts-state-img"
                    alt={chart.stateName}
                  />
                </div>
                <div className="trending-charts-card-info">
                  <h3>{chart.stateName}</h3>
                </div>
              </div>
            ))}
      </div>
    </section>
  );
};